import { Component, EventEmitter, Input, OnChanges, Output, SimpleChanges } from '@angular/core';
import { CommonModule } from '@angular/common';
import { DrawerModule } from 'primeng/drawer';
import { ButtonModule } from 'primeng/button';
import { TagModule } from 'primeng/tag';
import { TooltipModule } from 'primeng/tooltip';
import { AssetService } from '../services/asset/asset.service';

export interface AssetHistoryItem {
  id: string;
  asset_id: string;
  event_type: string;
  action: string;
  remarks: string;
  reference_id?: string;
  reference_type?: string;
  user_id: string;
  user_name: string;
  user_role: string;
  user_dept: string;
  event_date: string;
  created_at: string;
}

@Component({
  selector: 'app-asset-history-modal',
  standalone: true,
  imports: [
    CommonModule,
    DrawerModule,
    ButtonModule,
    TagModule,
    TooltipModule
  ],
  templateUrl: './asset-history-modal.component.html',
  styleUrls: ['./asset-history-modal.component.css']
})
export class AssetHistoryModalComponent implements OnChanges {
  @Input() visible = false;
  @Input() assetId: string | null = null;
  @Output() visibleChange = new EventEmitter<boolean>();

  historyItems: AssetHistoryItem[] = [];
  isLoading = false;
  totalRecords = 0;

  // Pagination
  limit = 20;
  offset = 0;

  // Expose Math for template usage
  Math = Math;

  constructor(private assetService: AssetService) {}

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['visible'] && this.visible && this.assetId) {
      this.loadHistory();
    }
  }

  loadHistory(): void {
    if (!this.assetId) return;

    this.isLoading = true;
    this.assetService.getAssetHistory(this.assetId, this.limit, this.offset).subscribe({
      next: (response) => {
        if (response?.data) {
          this.historyItems = response.data.history || [];
          this.totalRecords = response.data.total || 0;
        }
        this.isLoading = false;
      },
      error: (err) => {
        console.error('Failed to load asset history:', err);
        this.historyItems = [];
        this.isLoading = false;
      }
    });
  }

  onPageChange(event: any): void {
    this.offset = event.first;
    this.limit = event.rows;
    this.loadHistory();
  }

  closeModal(): void {
    this.visible = false;
    this.visibleChange.emit(false);
    // Reset pagination
    this.offset = 0;
    this.historyItems = [];
  }

  formatDate(dateStr: string): string {
    if (!dateStr) return '-';
    const date = new Date(dateStr);
    const day = String(date.getDate()).padStart(2, '0');
    const month = String(date.getMonth() + 1).padStart(2, '0');
    const year = date.getFullYear();
    return `${day}-${month}-${year}`;
  }

  formatTime(dateStr: string): string {
    if (!dateStr) return '';
    const date = new Date(dateStr);
    const hours = String(date.getHours()).padStart(2, '0');
    const minutes = String(date.getMinutes()).padStart(2, '0');
    const ampm = date.getHours() >= 12 ? 'PM' : 'AM';
    const displayHours = date.getHours() % 12 || 12;
    return `${String(displayHours).padStart(2, '0')}:${minutes} ${ampm}`;
  }
}
